var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "j-modal",
    {
      staticClass: "j-super-query-modal",
      staticStyle: { top: "5%", "max-height": "95%" },
      attrs: {
        title: "消息推送",
        width: 600,
        visible: _vm.visible,
        mask: true,
        fullscreen: _vm.izMobile,
        okText: "发送",
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
    },
    [_c("div", [_vm._v(_vm._s(_vm.content))])]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }